// 表單上方的固定說明文字。內容為主辦單位提供，非資料庫設定。

/** 計畫正式名稱（頁首大標） */
export const PROJECT_TITLE = "2026 國立東華大學數位教育志工計畫";
/** 本表單用途（副標） */
export const FORM_SUBTITLE = "115 學年度上學期・場次出席調查表";
/** 瀏覽器分頁 / 對外標題 */
export const FULL_TITLE = `${PROJECT_TITLE}｜${FORM_SUBTITLE}`;

export const CONTACT = {
  hotline: "0809-088-799",
  email: "service@straighta.com.tw",
};

export const INTRO_PARAGRAPHS = [
  "親愛的種子教師與志工們您好：",
  "本表單為 115 學年度上學期人力調查，請勾選您可出席的服務時段，我們會依結果盤點人力、安排實際上課節次。",
];

export const SERVICE_RULES = {
  heading: "115 學年度上學期｜服務時數規劃",
  subheading: "服務規定",
  body: ["完成計畫需累積至少 4 小時服務時數。"],
};

/**
 * 注意事項：以強調框呈現。每則為片段陣列，字串照常顯示，
 * { hl } 物件會套上重點色（warn = 橘、note = 藍）。
 */
export const NOTES = {
  heading: "注意事項",
  items: [
    [
      "AR 伴讀每節認列 2 小時：含課前約 1 小時到校準備、課後整理活動物資；請預留單節前後約 2 小時並確認能全程出席。",
    ],
    [
      "每節名額：英文種子教師 1 位、活動志工 2 位。",
      { hl: "warn", text: "額滿仍可勾選" },
      "，系統依送出時間排遞補序位（1、2、3…），建議多勾幾節。",
    ],
    ["未達 4 小時可先「暫存」，請於截止日前補選完成。"],
    [
      "服務日期（每雙週四，共 10 天）：9/10、9/24、10/8、10/22、11/5、11/19、12/3、12/17、12/31、1/14。",
      { hl: "note", text: "實際服務節次，以人力盤點結果及學校最終確認為準。" },
    ],
    ["稻香國小上午第 3、4 節、吉安國小下午第 5、6 節，逐節勾選。"],
  ] as (string | { hl: "warn" | "note"; text: string })[][],
};

export const WARN_UNDER_HOURS =
  "目前尚未達最低 4 小時服務時數，可先暫存，請於截止日前補選完成。";
